import { IPopularSearchAttributesValue, ResultObjectType } from '@cbgms/api'
import { ResultTitle } from './Title'
import { Grid, Typography } from '@mui/material'
import { useCallback } from 'react'
import { TyreIcon } from '@carsys/ui/src/icons/TyreIcon'

export interface TyreSizeResultProps {
  Type: ResultObjectType
  clearQuery: () => void
  hasGroupHeader: boolean
  primaryAction: () => Promise<void>
  option: IPopularSearchAttributesValue
}

const TyreSizeResult: React.FC<TyreSizeResultProps> = ({ option, hasGroupHeader, primaryAction }) => {
  const onClick = useCallback(
    (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
      e.stopPropagation()
      primaryAction()
    },
    [primaryAction]
  )
  return (
    <Grid container key={option.DisplayName} sx={{ margin: 0, cursor: 'pointer' }} onClick={onClick}>
      <ResultTitle resultType={ResultObjectType.TyreSize} isTitleVisible={!hasGroupHeader} />
      <Grid item display='flex' alignItems='center'>
        <TyreIcon fontSize='small' sx={theme => ({ color: theme.palette.LKQGrey.background.modest })} />
        <Typography sx={{ pl: 1, pr: 1 }}>{option.DisplayName}</Typography>
      </Grid>
    </Grid>
  )
}

export default TyreSizeResult
